import React, { useContext, useEffect, useState } from 'react';
import { useCentralCalls }                        from '@src/rest/CentralCalls';
import {DashGridItem}                             from "@src/views/pages/projects/dash/DashGrid";
import {Loader}                                   from "semantic-ui-react";
import { DashScopeContext }                       from './DashScopeContext';

interface DashItemLoaderProps {

    item: DashGridItem;
    projectVersionId?: string;
    userId: string;
    projectId?:string;
    filterParams?:any;
    renderFunctionComponent: (data: any) => React.ReactNode;
    chartType?: string,
    setChartData: (data:any)  => void;
}



const DashItemLoader: React.FC<DashItemLoaderProps> = ( props ) => {

    const { item,  projectVersionId, userId, projectId, filterParams } = props
    const { params: scopeParams } = useContext( DashScopeContext );

    const {
         getDashChartData: getDashItemData,
         getDashPivotTableData: getDashPivotTableItemData,
         TableSelect: getDashTableItemData, executeStoredProcedure } = useCentralCalls(),
         [ itemData, setItemData ]                                   = useState({}),
         [ loading, setLoading ]                                     = useState(true);

    const fetchItemData = async () => {
        try {

            setLoading(true);

            let data: any;

            const baseParams = {
                ...scopeParams,
                projectVersionId,
                userId,
                projectId,
                filterParams,
                ignoreFilter: item.ignoreFilter,
                paramName:item.paramName
            };

            switch (item.chartType) {
                case 'table':
                    if (item.pivotColumn && item.pivotDataColumn && item.pivotIdColumn) {
                        data = await getDashPivotTableItemData(

                            item.procedureName,
                            item.pivotColumn,
                            item.pivotDataColumn,
                            item.pivotIdColumn,
                            baseParams
                        );
                    } else {
                        data = await executeStoredProcedure(item.procedureName, baseParams);
                    }
                    break;


                case 'singleValue': {
                    const result = await executeStoredProcedure(item.procedureName, baseParams);
                    if (Array.isArray(result) && result.length > 0) {
                    data = result[0]?.value;

                    } else if (typeof result === 'object' && result !== null) {

                    data = Object.values(result)[0];

                    } else {
                    data = result;

                    }
                    break;
            }

                case 'filterList':
                    console.log('loading filter list');
                    if (item.tableName === 'BusinessFunction') {
                        console.log('in filter list tableName is businesFunction');

                        // @TODO MAP-797 Refactor Point
                        data = Object.entries([]) // BUSINESS_FUNCTION_IDS
                            .filter(([key]) => isNaN(Number(key)))
                            .map(([key, value]) => ({
                                key: value,
                                value,
                                text: key,
                            }));

                    }
                    else if (item.tableName) {
                        console.log('in table name' + item.tableName);
                        data = await getDashTableItemData(item.tableName, baseParams);
                    }
                    else if(item.procedureName){
                        console.log('in filterlist proc name' + item.procedureName);
                        console.log({ projectVersionId, userId, projectId, filterParams });
                         data = await executeStoredProcedure(item.procedureName, { ...scopeParams, projectVersionId, userId, projectId, filterParams });
                         console.log(data);

                    }
                    break;
                case 'summaryView': {

                    const result = await executeStoredProcedure(item.procedureName, { ...scopeParams, projectVersionId, userId, projectId, filterParams });
                    data = result;
                    break;
                }
                case 'aiContent': {

                    const result = await executeStoredProcedure(item.procedureName, { ...scopeParams, projectVersionId, userId, projectId, filterParams });
                    data = result;
                    break;
                }
                default:

                    const chartdata = await getDashItemData(
                        item.procedureName,
                        item.chartType,
                        baseParams
                    );
                    data = await hackColors(chartdata);

                    break;
            }

            setItemData(data);
            props.setChartData(data);
        } catch (error) {
            console.error('Error fetching Dashboard Item data:', error);
            setItemData({});
        } finally {
            setLoading(false);
        }
    };
    const hackColors = async (chartData) => {
        if (!chartData || !chartData.datasets || !Array.isArray(chartData.datasets) || !chartData.labels) {
            return chartData; // Return as-is if structure is incorrect
        }

        const colorPalette = [
            "#235E76", // Deep Blue-Teal
            "#A1B262", // Muted Olive Green
            "#A28754", // Warm Golden Brown
            "#6F3166", // Deep Plum
            "#F46621", // Vibrant Orange
            "#4E79A7", // Rich Blue
            "#EDC949", // Golden Yellow
            "#E15759", // Deep Red
            "#76B7B2", // Muted Teal
            "#59A14F", // Earthy Green
            "#F28E2B", // Bold Orange
            "#AF7AA1", // Dusty Purple
            "#FF9DA7", // Soft Pink
            "#9C755F", // Warm Brown
            "#BAB0AC"  // Neutral Gray
        ];

        const presetColors: Record<string, number> = {
            "MarketAccess": 0,  // Deep Blue-Teal
            "Marketing": 1,      // Muted Olive Green
            "MarketingAnalytics": 2, // Warm Golden Brown
            "MedicalAffairs": 3, // Deep Plum
            "OtherCorporate": 4, // Vibrant Orange
            "SalesCommercial": 5 // Rich Blue
        };

        if (chartData.datasets.length === 1) {
            // Existing logic for a single dataset
            const updatedDatasets = chartData.datasets.map(dataset => {
                if (!dataset.data || !Array.isArray(dataset.data)) {
                    return dataset;
                }

                // Replace colors sequentially from colorPalette
                const newBackgroundColors = dataset.data.map((_, index) => colorPalette[index % colorPalette.length]);
                const newBorderColors = dataset.data.map((_, index) => colorPalette[index % colorPalette.length]);

                // Apply preset colors where applicable
                const finalBackgroundColors = dataset.data.map((_, index) => {
                    const label = chartData.labels[index] || ""; // Ensure label exists
                    return label in presetColors ? colorPalette[presetColors[label]] : newBackgroundColors[index];
                });

                const finalBorderColors = dataset.data.map((_, index) => {
                    const label = chartData.labels[index] || "";
                    return label in presetColors ? colorPalette[presetColors[label]] : newBorderColors[index];
                });

                return {
                    ...dataset,
                    backgroundColor: finalBackgroundColors,
                    borderColor: finalBorderColors
                };
            });

            return {
                ...chartData,
                datasets: updatedDatasets
            };
        } else {
            // New logic for multiple datasets
            const updatedDatasets = chartData.datasets.map((dataset, datasetIndex) => {
                if (!dataset.data || !Array.isArray(dataset.data) || !dataset.label) {
                    return dataset;
                }

                // Determine the color based on dataset label
                const datasetColor = dataset.label in presetColors
                    ? colorPalette[presetColors[dataset.label]]
                    : colorPalette[datasetIndex % colorPalette.length];

                // Handle special cases for line and bar charts
                if (item.chartType === "line") {
                    return {
                        ...dataset,
                        backgroundColor: datasetColor, // Transparent for line charts
                        borderColor: datasetColor, // Single color for lines
                        pointBackgroundColor: datasetColor,
                        pointBorderColor: datasetColor
                    };
                } else if (item.chartType === "bar") {
                    return {
                        ...dataset,
                        backgroundColor: dataset.data.map(() => datasetColor), // Array for bars
                        borderColor: dataset.data.map(() => datasetColor)
                    };
                } else {
                    // Default behavior (for pie, doughnut, etc.)
                    return {
                        ...dataset,
                        backgroundColor: dataset.data.map(() => datasetColor),
                        borderColor: dataset.data.map(() => datasetColor)
                    };
                }
            });

            return {
                ...chartData,
                datasets: updatedDatasets
            };
        }
    };
    useEffect(() => {

     setLoading(false)

    }, [itemData]);


    useEffect(() => {

        fetchItemData();

    }, [projectVersionId, item, filterParams, scopeParams]);


    return (
        <div style={{ height: '100%', width: '100%', overflow: 'hidden', position: 'relative' }}>
            { loading
                ? (
                    <div style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10,
                        background: 'rgba(255,255,255,0.85)',
                    }}>
                        <Loader active inline size="small" />
                        <span style={{
                            fontSize: '0.72rem',
                            fontWeight: 600,
                            color: 'rgba(0,0,0,0.35)',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                        }}>
                            Loading…
                        </span>
                    </div>
                )
                : props.renderFunctionComponent(itemData)
            }
        </div>
    )

}

export default DashItemLoader;
